import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { CalculationType } from '../../../enums/calculation-type.enum';

@Component({
    selector: 'app-tightening-method',
    templateUrl: './tightening-method.component.html',
    styleUrls: ['./tightening-method.component.scss'],
})
export class TighteningMethodComponent implements OnInit {
    @Input() cssClass;
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Input()
    set calculationType(value: string | number) {
        this._calculationType = value;
        if (this._calculationType == CalculationType.Clamp) {
            this.stateOptions = [{ label: 'Torque', value: 'Torque' }];
        }
    }
    get calculationType(): string | number {
        return this._calculationType;
    }
    stateOptions: any[];
    tooltip_position = 'above';
    _calculationType: string | number;

    constructor(
        private globalEmittersService: GlobalEmittersService,
        private router: Router
    ) {
        if (this.router.url == '/informate/clamp/false' || router.url == '/informate/clamp/true' || this.calculationType == CalculationType.Clamp) {
            this.stateOptions = [{ label: 'Torque', value: 'Torque' }];
        } else {
            this.stateOptions = [
                { label: 'Torque', value: 'Torque' },
                { label: 'Tension', value: 'Tension' },
            ];
        }
    }

    ngOnInit(): void {
        this.form.markAllAsTouched();
        this.form.get('calcMethod').valueChanges.subscribe((res) => {
            if (res) this.globalEmittersService.tighteningMethod.next(res);
        });
    }
}
